import React from 'react'

// Components import
import Navbar from '../../../components/commons/navbar/Navbar.component'
import Footer from '../../../components/commons/footer/Footer.component'

interface ChildrenProp {
  children: React.ReactNode
}

const MainLayout = ({ children }: ChildrenProp) => (
	<div>
		<Navbar />
		{children}
		<Footer />
	</div>
)

export default MainLayout
